import { makeStyles } from '@material-ui/core';
import { EventData } from '../../types/EventData';
import { InviteStatus } from '../common/InviteStatus';
import { TagChip } from '../common/TagChip';

const useStyles = makeStyles(theme => ({
  datetimeContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5em',
    whiteSpace: 'nowrap',
  },
  time: {
    fontSize: '0.875rem',
  },
  tags: {
    display: 'flex',
    gap: '0.5em',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-end',
  },
  status: {
    whiteSpace: 'nowrap',
  },
  tagChip: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

interface DateTimeCellProps {
  date: string;
  time: string;
}
export const DateTimeCell = ({ date, time }: DateTimeCellProps) => {
  const classes = useStyles();

  return (
    <div className={classes.datetimeContainer} data-calendar-cell="datetime">
      <span data-calendar-cell-value="date">{date}</span>
      <span data-calendar-cell-value="time" className={classes.time}>
        {time}
      </span>
    </div>
  );
};

export const TitleCell = ({ title }: { title: React.ReactNode }) => {
  return (
    <div data-calendar-cell="title">
      <span data-calendar-cell-value="title">{title}</span>
    </div>
  );
};

export const TagsCell = ({ tags }: { tags: string[] }) => {
  const classes = useStyles();

  const chips = tags?.map((t: string) => (
    <TagChip key={t} variant="outlined" label={t} className={classes.tagChip} />
  ));

  return (
    <div data-calendar-cell="tags" className={classes.tags}>
      {chips}
    </div>
  );
};

export const LocationCell = ({ location }: { location: string }) => {
  return (
    <div data-calendar-cell="location">
      <span>{location}</span>
    </div>
  );
};

export const StatusCell = ({ eventData }: { eventData: EventData }) => {
  const classes = useStyles();

  return (
    <div data-calendar-cell="action" className={classes.status}>
      <InviteStatus eventData={eventData} isPrimary={false} />
    </div>
  );
};
